<template>
  <v-app>
    <template v-if="isAuthenticated">
      <router-view />
    </template>
    <template v-else-if="processingAuthentication">
      <div class="d-flex align-center justify-center" style="height: 30vh">
        <v-progress-circular color="primary" indeterminate class="mr-3"></v-progress-circular>
        Login wird geprüft...
      </div>
    </template>
    <template v-else>
      <div class="d-flex align-center justify-center" style="height: 30vh">
        <v-icon class="mdi mdi-account-cancel mr-4" size="x-large"></v-icon>
        Ihr Login konnte nicht verifiziert werden.<br />
        Bitte laden Sie die Seite neu.
      </div>
    </template>
  </v-app>
</template>

<script lang="ts" setup>
import AuthService from "@/api/AuthService";
import { useStorage } from "vue3-storage";
import { useUserStore } from "@/stores/userStore";
import { useRoute, useRouter } from "vue-router";

const userStore = useUserStore();
const authService = new AuthService();
const storage = useStorage();
const router = useRouter();
const route = useRoute();

onMounted(async () => {
  document.title = import.meta.env.VITE_APP_TITLE;

  await checkAuth();
});

const processingAuthentication = ref(false);
const isAuthenticated = ref(false);

const consumeOneTimeTokenFromUrl = async () => {
  const oneTimeToken = new URLSearchParams(window.location.hash.slice(1)).get("ott");
  if (oneTimeToken) {
    // clear the fragment via vue-router (not history.replaceState) and await isReady()
    // so vue-router doesn't re-apply its cached hash on its still-pending initial navigation
    await router.isReady();
    await router.replace({ path: route.path, query: route.query, hash: "" });
  }
  return oneTimeToken;
};

const tryAuthenticate = async () => {
  const oneTimeToken = await consumeOneTimeTokenFromUrl();
  if (oneTimeToken) {
    const data = await authService.getUserToken(oneTimeToken);
    if (data.success && data.data) {
      storage.setStorageSync("token", data.data.token);
      return true;
    }
  }
  return !!storage.getStorageSync("token");
};

const startSessionPoll = () => {
  window.setInterval(async () => {
    const data = await authService.checkLogin();
    if (!data || !data.success || !data.data.success) {
      storage.removeStorageSync("token");
      isAuthenticated.value = false;
    }
  }, 30000);
};

const checkAuth = async () => {
  processingAuthentication.value = true;
  isAuthenticated.value = await tryAuthenticate();
  processingAuthentication.value = false;

  if (isAuthenticated.value) {
    startSessionPoll();
    await userStore.loadUserConfig("extended-filter", "task-item-package");
    await userStore.loadWorkProject();
    await userStore.loadUserInfo();
  }
};
</script>
